import {apiArray}                       from "@Common/logic/api-array";
import {applyResultCart}                from "@Common/logic/checkout/common/apply-result-cart";
import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {findLast, unique}               from "@Common/utils/collections";
import {chain}                          from "@Common/utils/fs";

export const addPromoCode = (code, {apis}) => ({
    action: async (cart) => {
        const result = await apis.next.cart.updateCart(chain(
            cart,
            (_) => setNestedValue(_, ["credits", "promoCodes!arr", 0, "code"], code),
        ));

        return {
            error: getErrorMsgs(result),
            change: applyResultCart(result),
        };
    },
});

const getErrorMsgs = (result) => {
    const errors = getNestedValue(result, ["paymentErrors", "promoCodes"]);
    if (!errors?.length) {
        return null;
    }

    const getItemIds = () => chain(
        errors.filter((e) => e.error === 1).map((e) => e.itemId),
        unique,
    );

    const paymentErrorMsg = findLast(errors, (e) => e.error === 1)?.promoCodeMessage;

    return {
        errorMessages: [
            paymentErrorMsg && (
                paymentErrorMsg +
                " - " +
                getItemIds().join(", ")
            ),
            findLast(errors, (e) => e.lessDiscount === 1)?.promoCodeMessage,
        ]
            .filter(v=>v)
        ,
        appliedCodes: apiArray(result.appliedCredits?.promoCodes),
    };
};
